<template>
  <div v-if="isLoading" class="spinner mx-auto"></div>

  <div v-else-if="contactMessages === null || contactMessages.length === 0">
    <ZeroState> Send a message to start a conversation</ZeroState>
  </div>

  <div v-else :id="`messages-${contactId}`" class="scroll-container">
    <div v-for="message in contactMessages" :key="message.id">
      <div v-if="message.message_type == 'Customer'" class="chat chat-start">
        <div class="chat-bubble text-sm break-words">
          <img v-if="message.telco_media_url" :src="message.telco_media_url" />
          {{ message.body }}
        </div>
        <div class="chat-footer opacity-50">
          <time class="text-xs opacity-50">{{ fromNow(message.created_at) }}</time>
        </div>
      </div>
      <div v-else class="chat chat-end">
        <div
          v-if="message.telco_message_status == 'undelivered' || message.telco_message_status == 'delivery_failed'"
          class="chat-image"
        >
          <div class="tooltip tooltip-left tooltip-error" :data-tip="message.telco_message_error">
            <vue-feather type="alert-circle" class="text-error cursor-pointer" />
          </div>
        </div>
        <div class="chat-bubble text-sm break-words">{{ message.body }}</div>
        <div class="chat-footer opacity-50">
          <time class="text-xs opacity-50">{{ fromNow(message.created_at) }}</time>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import DateUtility from '../../../utilities/dates';
import type { ContactMessageEntity } from '@/api/entity_types/ContactMessage';
import ZeroState from '@/components/ZeroState.vue';

const { fromNow } = DateUtility;

const { contactId, isLoading, contactMessages } = defineProps<{
  contactId: number;
  isLoading: boolean;
  contactMessages: ContactMessageEntity[];
}>();
</script>

<style scoped>
@reference "tailwindcss";

.scroll-container {
  @apply overflow-y-auto overflow-x-hidden flex flex-col-reverse;
}
</style>
